import api from './api';
import { MtdOrdersResponse } from '../types';

export interface MtdOrdersFilters {
  sales_officer_id?: number;
  date_from?: string;
  date_to?: string;
}

export const orderReportService = {
  getMtdOrders: async (filters?: MtdOrdersFilters): Promise<MtdOrdersResponse> => {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') {
          params.append(k, String(v));
        }
      });
    }
    const response = await api.get(`/api/reports/orders-mtd?${params.toString()}`);
    return response.data;
  },
};
